import moment from 'moment';

import type { DateInterface } from '../../interface/date';

// Formato delle date nello store (appointmentSlot.date) e nelle chiavi di DateInterface
export const STORE_DATE_FORMAT = 'YYYY/MM/DD';
// Formato DateOnly delle API (converter globale della B2cApi)
export const API_DATE_FORMAT = 'YYYY-MM-DD';

export const toApiDate = (date: string): string =>
  moment(date, STORE_DATE_FORMAT).format(API_DATE_FORMAT);

export const fromApiDate = (date: string): string =>
  moment(date, API_DATE_FORMAT).format(STORE_DATE_FORMAT);

// TimeOnly 'HH:mm:ss' delle API -> 'HH:mm' come gli orari dell'HourPicker
export const toHourMinutes = (time: string): string =>
  moment(time, 'HH:mm:ss').format('HH:mm');

export const getActiveDates = (data?: DateInterface): string[] =>
  data === undefined
    ? []
    : Object.keys(data).filter((date) => data[date].active);

// Unione dei giorni liberi di più centri, senza doppioni e in ordine di data
export const mergeDates = (lists: string[][]): string[] =>
  Array.from(new Set(lists.flat())).sort();

// Giorni da startDate a endDate compresi, attivi se presenti in activeDates: stessa forma
// della DateInterface degli slot classici, così la settimana si disegna come nel WeekPicker
export const buildDateInterface = (
  startDate: string,
  endDate: string,
  activeDates: string[]
): DateInterface => {
  const active = new Set(activeDates);
  const end = moment(endDate, STORE_DATE_FORMAT);
  const result: DateInterface = {};

  for (
    const day = moment(startDate, STORE_DATE_FORMAT);
    !day.isAfter(end, 'day');
    day.add(1, 'days')
  ) {
    const key = day.format(STORE_DATE_FORMAT);
    result[key] = {
      date: day.clone(),
      daysOfWeek: day.day(),
      day: day.date(),
      active: active.has(key),
    };
  }
  return result;
};

// Stessa regola di avanzamento del WeekPicker: se il giorno scelto non è attivo si passa al
// prossimo giorno attivo della finestra. Se la finestra non ne ha, restituisce il primo giorno
// dopo la finestra (isInWindow = false): il chiamante sposta lì la finestra e riprova.
// undefined se il giorno scelto è attivo o fuori dalla finestra.
export const findNextActiveDay = (
  data: DateInterface,
  selectedDay: string
): { date: string; isInWindow: boolean } | undefined => {
  if (!(selectedDay in data) || data[selectedDay].active) return undefined;

  const day = moment(selectedDay, STORE_DATE_FORMAT).add(1, 'days');
  let key = day.format(STORE_DATE_FORMAT);
  while (key in data && !data[key].active) {
    day.add(1, 'days');
    key = day.format(STORE_DATE_FORMAT);
  }
  return { date: key, isInWindow: key in data };
};
